export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Users'
    },
    unique: [],
    lang: {
        name: 'Users',
        category: ['User', 'Plays'],
        description: 'Number of users that played the game.',
        views: ['list', 'sheet', 'grid'],
        contexts: ['gameplays'],
    },
    filters: [],
    types: ['group','buddies']
}